import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';

const initialState = {
  isDataRightsConsentPending: false,
  createDataRightsConsentSuccess: false,
  isGetDataRightsConsetsPending: false
};

export const createDataRightsConsent = createAsyncThunk(
  'createDataRightsConsent',
  async ({ consentPayload, solutionId, listingVersion, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/${listingVersion}/consents`,
      {
        consent: consentPayload
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const updateDataRights = createAsyncThunk(
  'updateDataRights',
  async ({ cmfNumbers, token }) => {
    let response = axios.post(
      `${environmentURLs.REACT_APP_MP_SALESFORCE_INTEGRATION}/salesforce/datarights/update`,
      {
        flag: "Yes",
        cmfNumbers: cmfNumbers
      },
      {
        headers: {
          Authorization: token
        }
      }
    );
    return response;
  }
);

export const getDataRightsConsets = createAsyncThunk(
  'getDataRightsConsets',
  async ({ solutionId, entityId, token }) => {
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/consents?entityId=${entityId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return {
      entityId,
      response
    };
  }
);

export const getUserDetails = createAsyncThunk(
  'getUserDetails',
  async ({ loggedInUserEmail,firstName,lastName,token}) => {
    let email =loggedInUserEmail;
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/user/role?email=${email}&firstName=${firstName}&lastName=${lastName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const dataRightsSlice = createSlice({
  name: 'dataRightsSlice',
  initialState,
  reducers: {
  },
  extraReducers: {
    [createDataRightsConsent.fulfilled]: (state, action) => {
      state.isDataRightsConsentPending = false;
      state.createConsentSuccess = true;
    },
    [createDataRightsConsent.pending]: state => {
      state.isDataRightsConsentPending = true;
    },
    [createDataRightsConsent.rejected]: state => {
      state.isDataRightsConsentPending = false;
    },
    [getDataRightsConsets.fulfilled]: (state, action) => {
      state.isGetDataRightsConsetsPending = false;
    },
    [getDataRightsConsets.pending]: state => {
      state.isGetDataRightsConsetsPending = true;
    },
    [getDataRightsConsets.rejected]: state => {
      state.isGetDataRightsConsetsPending = false;
    }
  }
});

export default dataRightsSlice.reducer;